import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useGetQuery, usePostQuery } from "hooks";
import { Button, Card, Dropdown, Title, Wrapper } from "components";
import { apiFetch } from "actions/apiFetch";
import { useStateValue } from "providers";
import { PanelChooser, ConfigModal } from "../components";
import { useToast } from "hooks";

export const HostDashEdit = () => {
  const { slug } = useParams();
  const [
    {
      session: { user },
    },
  ] = useStateValue();
  const [state, setState] = useState({});
  const [configSlot, setConfigSlot] = useState(null);
  const { showToast, toastElement } = useToast();
  const { data, reFetch } = useGetQuery({
    url: `/host/queue/${slug}`,
  });

  const { post } = usePostQuery({
    method: "POST",
    url: "/host/queue_items/",
  });
  const { post: put } = usePostQuery({
    method: "PUT",
    url: "/host/queue_items/",
  });

  useEffect(() => {
    if (!data?.queue) return;
    const { id, state, type } = data.queue;
    setState({ id, state, type });
  }, [data]);

  const handleChange = ({ target: { name, value } }) => {
    setState({ ...state, [name]: value });
  };

  const saveDash = () => {
    apiFetch({ method: "POST", path: `/queues/${state.id}`, payload: state });
  };

  const updatePanel = ({ target: { name, value } }) => {
    const item = data?.queue?.QueueItems.find((i) => i?.details?.slot === name);
    if (item) {
      // A different panel type means the old type's config no longer applies
      if (item.type !== value.type) delete item.details.config;
      item.type = value.type;
      item.details.type = value.type;
      put(item, `/host/queue_items/${item.id}`);
    } else {
      const item = {
        queue_id: data?.queue?.id,
        type: value?.type,
        user_id: user?.id,
        details: {
          slot: name,
          queue_id: data?.queue?.id,
          type: value?.type,
          user_id: user?.id,
        },
      };
      post(item, `/host/queue_items/${item.id}`);
      reFetch();
    }
  };

  const configItem = data?.queue?.QueueItems?.find(
    (i) => i?.details?.slot === configSlot
  );

  const saveConfig = async (config) => {
    if (!configItem) {
      showToast("Panel is still saving, try again in a moment");
      return;
    }
    await put(
      { details: { ...configItem.details, config } },
      `/host/queue_items/${configItem.id}`
    );
    setConfigSlot(null);
    reFetch(true);
  };

  return (
    <Card margin="0">
      <Wrapper padding="1.5rem 1rem">
        <Title level="2">
          {data?.queue?.name} <small>({data?.queue?.type})</small>
        </Title>
        <Title level="4">{data?.queue?.Address?.name}</Title>
        <PanelChooser
          panels={
            [...(data?.queue?.QueueItems || [])].sort(
              (a, b) => a?.details?.slot - b?.details?.slot
            )
          }
          onChange={updatePanel}
          onConfigure={(s) => setConfigSlot(s)}
        />
        <ConfigModal
          show={configSlot !== null}
          type={configItem?.type}
          config={configItem?.details?.config}
          hideModal={() => setConfigSlot(null)}
          onSave={saveConfig}
        />
        {toastElement}
      </Wrapper>
      <Wrapper padding="0.5rem 0.5rem 1rem">
        <Dropdown
          name="state"
          value={state?.state}
          onChange={handleChange}
          data={[
            ["Pending", "pending"],
            ["Active", "active"],
            ["Deleted", "deleted"],
            ["Completed", "completed"],
          ]}
        />
      </Wrapper>
      <Wrapper
        css={`
          display: flex;
          justify-content: flex-end;
        `}
      >
        <Button className="large" onPress={saveDash}>
          Update
        </Button>
      </Wrapper>
    </Card>
  );
};
